"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaReturnGetChargeIdBBrasil = exports.yupReturnGetChargeIdBBrasil = exports.schemaReturnGetAllChargeBBrasil = exports.yupReturnGetAllChargeBBrasil = exports.schemaPaymentBBrasil = exports.yupPaymentBBrasil = exports.schemaChargeBB = exports.yupChargeBB = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupChargeBB = yup.object({
    numeroConvenio: yup.number().required().default(0).label('Convênio de cobrança, com 7 dígitos.'),
    numeroCarteira: yup.number().required().default(0).label('Número da carteira de cobrança.'),
    numeroVariacaoCarteira: yup.number().required().default(0).label('Número da variação da carteira de cobrança.'),
    codigoModalidade: yup
        .number()
        .required()
        .oneOf([1, 4], 'O campo deve ser 1 (Simples) ou 4 (Vinculada)')
        .default(1)
        .label('Modalidades de cobrança'),
    dataEmissao: yup.string().required().default('').label('Data emissão, no formato dd.mm.aaaa'),
    dataVencimento: yup.string().required().default('').label('Data vencimento, no formato dd.mm.aaaa'),
    valorOriginal: yup
        .number()
        .required()
        .default(0)
        .label('Valor do Boleto, deve ser maior que a soma dos campos (valorDesconto) e (valorAbatimento), se informados. '),
    valorAbatimento: yup.number().notRequired().default(0).label('Valor de dedução do boleto.'),
    quantidadeDiasProtesto: yup
        .number()
        .notRequired()
        .default(0)
        .label('Quantidade de dias após a data de vencimento do boleto para iniciar o processo de cobrança através de protesto. (3 a 5 dias úteis ou 6 a 29, 35, 40 ou 45 dias corridos)'),
    quantidadeDiasNegativacao: yup
        .number()
        .notRequired()
        .default(0)
        .label('Quantidade de dias corridos depois do vencimento do boleto para a negativação automática'),
    orgaoNegativador: yup
        .number()
        .notRequired()
        .oneOf([10, 11], 'O campo deve ser (10 - SERASA) ou (11 - QUOD)')
        .default(undefined)
        .label('Orgão negativador selecionado. (10 - SERASA) ou (11 - QUOD).'),
    indicadorAceiteTituloVencido: yup
        .string()
        .notRequired()
        .oneOf(['S', 'N'], 'O campo deve ser (S - Sim) ou (N - Não)')
        .default('S')
        .label('Indicador de que o boleto pode ou não ser recebido após o vencimento.'),
    numeroDiasLimiteRecebimento: yup
        .number()
        .notRequired()
        .default(0)
        .label('Quantidade de dias corridos para recebimento após o vencimento.'),
    codigoAceite: yup
        .string()
        .required()
        .oneOf(['A', 'N'], 'O campo deve ser (A - Aceito) ou (N - Não aceito)')
        .default('N')
        .label('Código para identificar se o boleto de cobrança foi aceito (reconhecimento da dívida pelo Pagador).'),
    codigoTipoTitulo: yup
        .number()
        .required()
        .oneOf([...Array(25).keys()].map((_, i) => i + 1).concat(31, 32, 33, 99), ' 1- CHEQUE 2- DUPLICATA MERCANTIL 3- DUPLICATA MTIL POR INDICACAO 4- DUPLICATA DE SERVICO 5- DUPLICATA DE SRVC P/INDICACAO 6- DUPLICATA RURAL 7- LETRA DE CAMBIO 8- NOTA DE CREDITO COMERCIAL 9- NOTA DE CREDITO A EXPORTACAO 10- NOTA DE CREDITO INDULTRIAL 11- NOTA DE CREDITO RURAL 12- NOTA PROMISSORIA 13- NOTA PROMISSORIA RURAL 14- TRIPLICATA MERCANTIL 15- TRIPLICATA DE SERVICO 16- NOTA DE SEGURO 17- RECIBO 18- FATURA 19- NOTA DE DEBITO 20- APOLICE DE SEGURO 21- MENSALIDADE ESCOLAR 22- PARCELA DE CONSORCIO 23- DIVIDA ATIVA DA UNIAO 24- DIVIDA ATIVA DE ESTADO 25- DIVIDA ATIVA DE MUNICIPIO 31- CARTAO DE CREDITO 32- BOLETO PROPOSTA 33- BOLETO APORTE 99- OUTROS.')
        .default(4)
        .label('Código para identificar o tipo de boleto de cobrança. '),
    descricaoTipoTitulo: yup.string().notRequired().default('DUPLICATA DE SERVICO').label('Descrição do tipo de boleto.'),
    indicadorPermissaoRecebimentoParcial: yup
        .string()
        .required()
        .oneOf(['S', 'N'], 'O campo deve ser (S - Sim) ou (N - Não)')
        .default('N')
        .label('Código para identificação da autorização de pagamento parcial do boleto.'),
    numeroTituloBeneficiario: yup
        .string()
        .notRequired()
        .max(15)
        .default('')
        .label('Número de identificação do boleto (equivalente ao SEU NÚMERO)'),
    campoUtilizacaoBeneficiario: yup
        .string()
        .notRequired()
        .max(30)
        .transform((value) => (value ? value.toUpperCase() : value))
        .default('')
        .label('Informações adicionais sobre o beneficiário.'),
    numeroTituloCliente: yup
        .string()
        .required()
        .max(20)
        .default('')
        .label('Número de identificação do boleto. Deve ser montado da seguinte forma: 000 + número do convênio (7 dígitos) + número de controle (10 dígitos).'),
    mensagemBloquetoOcorrencia: yup
        .string()
        .notRequired()
        .max(165)
        .default('')
        .label('Mensagem definida pelo beneficiário para ser impressa no boleto.'),
    desconto: yup
        .object({
        tipo: yup
            .number()
            .required()
            .oneOf([0, 1, 2, 3], 'O campo deve ser  0 - Sem desconto; 1 - Valor fixo até a data informada; 2 - percentual até a data informada; 3 - Desconto por dia de antecipação.')
            .default(0)
            .label('Tipo da forma de desconto.'),
        dataExpiracao: yup
            .string()
            .notRequired()
            .default(undefined)
            .label('Se tipo > 0, Definir uma data de expiração do desconto, no formato "dd.mm.aaaa".'),
        porcentagem: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 2, definir uma porcentagem de desconto >= 0.00 (formato decimal separado por ".")'),
        valor: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 1, definir um valor de desconto >= 0.00 (formato decimal separado por "."'),
    })
        .notRequired()
        .default(undefined),
    segundoDesconto: yup
        .object({
        dataExpiracao: yup
            .string()
            .notRequired()
            .default(undefined)
            .label('Define a data de expiração do desconto, no formato “dd.mm.aaaa”. Deve ser posterior a data de expiração do primeiro desconto.'),
        porcentagem: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 2, definir uma porcentagem de desconto >= 0.00 (formato decimal separado por ".")'),
        valor: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 1, definir um valor de desconto >= 0.00 (formato decimal separado por "."'),
    })
        .notRequired()
        .default(undefined)
        .label('Define a forma como será concedido um segundo desconto para o boleto. Só pode ser usado se for definido um primeiro desconto. O tipo do segundo desconto será igual ao do primeiro desconto.'),
    terceiroDesconto: yup
        .object({
        dataExpiracao: yup
            .string()
            .notRequired()
            .default(undefined)
            .label('Define a data de expiração do desconto, no formato “dd.mm.aaaa”. Deve ser posterior a data de expiração do primeiro desconto.'),
        porcentagem: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 2, definir uma porcentagem de desconto >= 0.00 (formato decimal separado por ".")'),
        valor: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 1, definir um valor de desconto >= 0.00 (formato decimal separado por "."'),
    })
        .notRequired()
        .default(undefined)
        .label('Define a forma como será concedido um segundo desconto para o boleto. Só pode ser usado se for definido um segund desconto. O tipo do terceiro desconto será igual ao do primeiro desconto.'),
    jurosMora: yup.object({
        tipo: yup
            .number()
            .required()
            .oneOf([0, 1, 2, 3], 'O campo deve ser  0 - Dispensa; 1 - Valor dia atraso; 2 - Taxa mensal; 3 - Isento.')
            .default(2)
            .label('Tipo de taxa de juros.'),
        porcentagem: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 2, definir uma porcentagem de juros >= 0.00 (formato decimal separado por ".").'),
        valor: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 1, definir um valor de juros >= 0.00 (formato decimal separado por ".").'),
    }),
    multa: yup.object({
        tipo: yup
            .number()
            .required()
            .oneOf([0, 1, 2, 3], 'O campo deve ser  0 - Dispensa; 1 - Valor dia atraso; 2 - Taxa mensal; 3 - Isento.')
            .default(2)
            .label('Tipo da forma da multa.'),
        data: yup
            .string()
            .notRequired()
            .default(undefined)
            .label('Se tipo > 0, Definir uma data de multa, no formato "dd.mm.aaaa"'),
        porcentagem: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 2, definir porcentagem >= 0.00 (formato decimal separado por ".").'),
        valor: yup
            .number()
            .notRequired()
            .default(undefined)
            .label('Se tipo = 1, definir valor do juros >= 0.00 (formato decimal separado por ".").'),
    }),
    pagador: yup.object({
        tipoInscricao: yup
            .number()
            .required()
            .oneOf([1, 2], '1 - CPF; 2 - CNPJ')
            .default(1)
            .label('Código que identifica o tipo de inscrição do Pagador.'),
        numeroInscricao: yup
            .number()
            .required()
            .default(0)
            .label('Número de inscrição do pagador. Para o tipo = 1, informar numero do CPF. Para o tipo = 2, informar numero do CNPJ.'),
        nome: yup.string().required().default('').label('Nome do pagador'),
        endereco: yup.string().required().default('').label('Endereço do pagador'),
        cep: yup.number().required().default(0).label('Cep do pagador'),
        cidade: yup.string().required().default('').label('Cidade do pagador'),
        bairro: yup.string().required().default('').label('Bairro do pagador'),
        uf: yup.string().required().default('').label('Uf do pagador'),
        telefone: yup.string().required().default('').label('Telefone do pagador'),
    }),
    beneficiarioFinal: yup
        .object({
        tipoInscricao: yup
            .number()
            .oneOf([1, 2], '1 - CPF; 2 - CNPJ')
            .label('Código que identifica o tipo de inscrição do Pagador.'),
        numeroInscricao: yup
            .number()
            .label('Número de inscrição do pagador. Para o tipo = 1, informar numero do CPF. Para o tipo = 2, informar numero do CNPJ.'),
        nome: yup.string().required().default('').label('Nome do pagador'),
    })
        .notRequired()
        .default(undefined),
    indicadorPix: yup
        .string()
        .required()
        .oneOf(['S', 'N'], 'O campo deve ser  (S - QRCODE DINAMICO) ou (N - SEM PIX)')
        .default('S')
        .label('Código para informar se o boleto terá um QRCode Pix atrelado.'),
});
exports.schemaChargeBB = exports.yupChargeBB.shape({});
exports.yupPaymentBBrasil = yup.object({
    id: yup.string().default('').label('Id da cobrança'),
    dataRegistro: yup.string().default('').label('Data de Registro'),
    dataVencimento: yup.string().default('').label('Data de Vencimento'),
    valorOriginal: yup.number().default(0).label('Valor Original'),
    valorPagoSacado: yup.number().default(0).label('Valor Pago Sacado'),
    numeroConvenio: yup.number().default(0).label('Número Convênio'),
    numeroOperacao: yup.number().default(0).label('Número Operação'),
    carteiraConvenio: yup.number().default(0).label('Carteira Convênio'),
    variacaoCarteiraConvenio: yup.number().default(0).label('Variação Carteira Convênio'),
    codigoEstadoBaixaOperacional: yup
        .mixed()
        .default(enums_1.EPaymentTypeBaixaBBrasil.CANCELAMENTO_DE_BAIXA_OPERACIONAL)
        .label('Código da baixo'),
    dataAgendamento: yup.string().default('').label('Data de Agendamento, Até 02/10/2024'),
    dataLiquidacao: yup.string().default('').label('Data de Liquidação, A partir 03/10/2024'),
    instituicaoAgendamento: yup.number().default(0).label('Instituição Agendamento, Até 02/10/2024'),
    instituicaoLiquidacao: yup.number().default(0).label('Instituição Liquidação, A partir 03/10/2024'),
    canalAgendamento: yup
        .mixed()
        .default(enums_1.EPaymentAttTypesBBrasil.AGENCIAS_POSTOS_TRADICIONAIS)
        .label('Canal de Agendamento, Até 02/10/2024'),
    canalLiquidacao: yup
        .mixed()
        .default(enums_1.EPaymentAttTypesBBrasil.AGENCIAS_POSTOS_TRADICIONAIS)
        .label('Canal de Liquidação, A partir 03/10/2024'),
    codigoModalidadeBoleto: yup.number().default(1).label('Modalidade do Boleto 1-Simples 4-Vinculada'),
    tipoPessoaPortador: yup
        .mixed()
        .default(enums_1.ETipoPessoaPortadorBBrasil.FISICA)
        .label('Tipo portador, para definir se o portador é PF ou PJ, A partir 03/10/2024'),
    identidadePortador: yup.string().default('').label('CPF ou CNPJ do portador, A partir 03/10/2024'),
    nomePortador: yup.string().default('').label('Nome do portador, A partir 03/10/2024'),
    canalPagamento: yup
        .mixed()
        .default(enums_1.ECanalPagamentoTypesBBrasil.AGENCIAS_POSTOS_TRADICIONAIS)
        .label('Canal de Pagamento, Até 02/10/2024'),
    formaPagamento: yup
        .mixed()
        .default(enums_1.EFormaPagamentoBBrasil.DEBITO_CONTA)
        .label('Para identificar a forma de pagamento do título, Até 02/10/2024'),
});
exports.schemaPaymentBBrasil = exports.yupPaymentBBrasil.shape({});
exports.yupReturnGetAllChargeBBrasil = yup.object({
    indicadorContinuidade: yup.string().default('').label('Indicador de que a consulta'),
    boletos: yup.array(yup.object({
        numeroBoletoBB: yup
            .string()
            .default('')
            .label('Número de identificação do boleto (Correspondente ao NOSSO NÚMERO)'),
        dataRegistro: yup.string().default('').label('Data de registro do boleto.'),
        dataVencimento: yup.string().default('').label('Data de vencimento do boleto'),
        valorOriginal: yup.number().default(0).label('Valor do boleto no registro.'),
        carteiraConvenio: yup.number().default(0).label('Número da carteira do convênio de cobrança.'),
        variacaoCarteiraConvenio: yup
            .number()
            .default(0)
            .label('Número da variação da carteira do convênio de cobrança.'),
        codigoEstadoTituloCobranca: yup
            .mixed()
            .default(enums_1.EPaymentStateBBrasil.NORMAL)
            .label('Código da situação atual do boleto'),
        estadoTituloCobranca: yup.string().default('').label('Texto da situação atual do boleto.'),
        contrato: yup.number().default(0).label('Código do contrato entre o Banco do Brasil e a empresa cliente.'),
        dataMovimento: yup
            .string()
            .default('')
            .label('Data do evento que baixou, protestou ou liquidou o boleto. No caso de títulos vigentes, ainda que vencidos, equivale a data de registro.'),
        dataCredito: yup.string().default('').label('Data do crédito dos valores ao beneficiário'),
        valorAtual: yup.number().default(0).label('Valor atualizado do boleto.'),
        valorPago: yup.number().default(0).label('Valor pago pelo pagador/sacado.'),
    })),
    quantidadeRegistros: yup.number().default(0).label('Quantidade de boletos que atendem os critérios da requisição.'),
    proximoIndice: yup.number().default(0).label('Número do último registro apresentado pela lista'),
});
exports.schemaReturnGetAllChargeBBrasil = exports.yupReturnGetAllChargeBBrasil.shape({});
exports.yupReturnGetChargeIdBBrasil = yup
    .object({
    codigoLinhaDigitavel: yup.string().default('').label('Codigo Linha Digitavel:'),
    textoEmailPagador: yup.string().default('').label('Texto Email Pagador'),
    textoMensagemBloquetoTitulo: yup.string().default('').label('Texto Mensagem Bloqueto Titulo'),
    codigoTipoMulta: yup.number().default(0).label('Codigo Tipo Multa'),
    codigoCanalPagamento: yup.number().default(0).label('Codigo Canal Pagamento'),
    numeroContratoCobranca: yup.number().default(0).label('Número Contrato Cobranca'),
    codigoTipoInscricaoSacado: yup.number().default(0).label('Codigo Tipo Inscricao Sacado'),
    numeroInscricaoSacadoCobranca: yup.number().default(0).label('Número Inscricao Sacado Cobranca'),
    codigoEstadoTituloCobranca: yup
        .mixed()
        .default(enums_1.EPaymentStateBBrasil.NORMAL)
        .label('Código da situação atual do boleto'),
    codigoTipoTituloCobranca: yup.number().default(0).label('Código Tipo Titulo Cobranca'),
    codigoModalidadeTitulo: yup.number().default(0).label('Código Modalidade Título'),
    codigoAceiteTituloCobranca: yup.string().default('').label('Código Aceite Título Cobranca'),
    codigoPrefixoDependenciaCobrador: yup.number().default(0).label('codigo Prefixo Dependencia Cobrador'),
    codigoIndicadorEconomico: yup.number().default(0).label('codigo Indicador Economico'),
    numeroTituloCedenteCobranca: yup.string().default('').label('numero Titulo Cedente Cobranca'),
    codigoTipoJuroMora: yup.number().default(0).label('codigo Tipo Juro Mora'),
    dataEmissaoTituloCobranca: yup.string().default('').label('dataEmissao Titulo Cobranca'),
    dataRegistroTituloCobranca: yup.string().default('').label('data Registro Titulo Cobranca'),
    dataVencimentoTituloCobranca: yup.string().default('').label('data Vencimento Titulo Cobranca'),
    valorOriginalTituloCobranca: yup.number().default(0).label('valor Original Titulo Cobranca'),
    valorAtualTituloCobranca: yup.number().default(0).label('valor Atual Titulo Cobranca'),
    valorPagamentoParcialTitulo: yup.number().default(0).label('valor Pagamento Parcial Titulo'),
    valorAbatimentoTituloCobranca: yup.number().default(0).label('valor Abatimento Titulo Cobranca'),
    percentualImpostoSobreOprFinanceirasTituloCobranca: yup
        .number()
        .default(0)
        .label('percentual Imposto Sobre Opr Financeiras Titulo Cobranca'),
    valorImpostoSobreOprFinanceirasTituloCobranca: yup
        .number()
        .default(0)
        .label('valor Imposto Sobre Opr Financeiras Titulo Cobranca'),
    valorMoedaTituloCobranca: yup.number().default(0).label('valor Moeda Titulo Cobranca'),
    percentualJuroMoraTitulo: yup.number().default(0).label('percentual Juro Mora Titulo'),
    valorJuroMoraTitulo: yup.number().default(0).label('valor Juro Mora Titulo'),
    percentualMultaTitulo: yup.number().default(0).label('percentual Multa Titulo'),
    valorMultaTituloCobranca: yup.number().default(0).label('valor Multa Titulo Cobranca'),
    quantidadeParcelaTituloCobranca: yup.number().default(0).label('quantidade Parcela Titulo Cobranca'),
    dataBaixaAutomaticoTitulo: yup.string().default('').label('data Baixa Automatico Titulo'),
    textoCampoUtilizacaoCedente: yup.string().default('').label('texto Campo Utilizacao Cedente'),
    indicadorCobrancaPartilhadoTitulo: yup.string().default('').label('indicador Cobranca Partilhado Titulo'),
    nomeSacadoCobranca: yup.string().default('').label('nome Sacado Cobranca'),
    textoEnderecoSacadoCobranca: yup.string().default('').label('texto Endereco Sacado Cobranca'),
    nomeBairroSacadoCobranca: yup.string().default('').label('nome Bairro Sacado Cobranca'),
    nomeMunicipioSacadoCobranca: yup.string().default('').label('nome Municipio Sacado Cobranca'),
    siglaUnidadeFederacaoSacadoCobranca: yup.string().default('').label('sigla Unidade Federacao Sacado Cobranca'),
    numeroCepSacadoCobranca: yup.number().default(0).label('numero Cep Sacado Cobranca'),
    valorMoedaAbatimentoTitulo: yup.number().default(0).label('valor Moeda Abatimento Titulo'),
    dataProtestoTituloCobranca: yup.string().default('').label('data Protesto Titulo Cobranca'),
    codigoTipoInscricaoSacador: yup.number().default(0).label('codigo Tipo Inscricao Sacador'),
    numeroInscricaoSacadorAvalista: yup.number().default(0).label('numero Inscricao Sacador Avalista'),
    nomeSacadorAvalistaTitulo: yup.string().default('').label('nome Sacador Avalista Titulo'),
    percentualDescontoTitulo: yup.number().default(0).label('percentual Desconto Titulo'),
    dataDescontoTitulo: yup.string().default('').label('data Desconto Titulo'),
    valorDescontoTitulo: yup.number().default(0).label('valor Desconto Titulo'),
    codigoDescontoTitulo: yup.number().default(0).label('codigo Desconto Titulo'),
    percentualSegundoDescontoTitulo: yup.number().default(0).label('percentual Segundo Desconto Titulo'),
    dataSegundoDescontoTitulo: yup.string().default('').label('data Segundo Desconto Titulo'),
    valorSegundoDescontoTitulo: yup.number().default(0).label('valor Segundo Desconto Titulo'),
    codigoSegundoDescontoTitulo: yup.number().default(0).label('codigo Segundo Desconto Titulo'),
    percentualTerceiroDescontoTitulo: yup.number().default(0).label('percentual Terceiro Desconto Titulo'),
    dataTerceiroDescontoTitulo: yup.string().default('').label('data Terceiro Desconto Titulo'),
    valorTerceiroDescontoTitulo: yup.number().default(0).label('valor Terceiro Desconto Titulo'),
    codigoTerceiroDescontoTitulo: yup.number().default(0).label('codigo Terceiro Desconto Titulo'),
    dataMultaTitulo: yup.string().default('').label('data Multa Titulo'),
    numeroCarteiraCobranca: yup.number().default(0).label('numero Carteira Cobranca'),
    numeroVariacaoCarteiraCobranca: yup.number().default(0).label('numero Variacao Carteira Cobranca'),
    quantidadeDiaProtesto: yup.number().default(0).label('quantidade Dia Protesto'),
    quantidadeDiaPrazoLimiteRecebimento: yup.number().default(0).label('quantidade Dia Prazo Limite Recebimento'),
    dataLimiteRecebimentoTitulo: yup.string().default('').label('data Limite Recebimento Titulo'),
    indicadorPermissaoRecebimentoParcial: yup.string().default('').label('indicador Permissao Recebimento Parcial'),
    textoCodigoBarrasTituloCobranca: yup.string().default('').label('texto Codigo Barras Titulo Cobranca'),
    codigoOcorrenciaCartorio: yup.number().default(0).label('codigo Ocorrencia Cartorio'),
    valorImpostoSobreOprFinanceirasRecebidoTitulo: yup
        .number()
        .default(0)
        .label('valor Imposto Sobre Opr Financeiras Recebido Titulo'),
    valorAbatimentoTotal: yup.number().default(0).label('valor Abatimento Total'),
    valorJuroMoraRecebido: yup.number().default(0).label('valor Juro Mora Recebido'),
    valorDescontoUtilizado: yup.number().default(0).label('valor Desconto Utilizado'),
    valorPagoSacado: yup.number().default(0).label('valor Pago Sacado'),
    valorCreditoCedente: yup.number().default(0).label('valor Credito Cedente'),
    codigoTipoLiquidacao: yup.number().default(0).label('codigo Tipo Liquidacao'),
    dataCreditoLiquidacao: yup.string().default('').label('data Credito Liquidacao'),
    dataRecebimentoTitulo: yup.string().default('').label('data Recebimento Titulo'),
    codigoPrefixoDependenciaRecebedor: yup.number().default(0).label('codigo Prefixo Dependencia Recebedor'),
    codigoNaturezaRecebimento: yup.number().default(0).label('codigo Natureza Recebimento'),
    numeroIdentidadeSacadoTituloCobranca: yup.string().default('').label('numero Identidade Sacado Titulo Cobranca'),
    codigoResponsavelAtualizacao: yup.string().default('').label('codigo Responsavel Atualizacao'),
    codigoTipoBaixaTitulo: yup.number().default(0).label('codigo Tipo Baixa Titulo'),
    valorMultaRecebido: yup.number().default(0).label('valor Multa Recebido'),
    valorReajuste: yup.number().default(0).label('valor Reajuste'),
    valorOutroRecebido: yup.number().default(0).label('valorOutro Recebido'),
    codigoIndicadorEconomicoUtilizadoInadimplencia: yup
        .number()
        .default(0)
        .label('codigo Indicador Economico Utilizado Inadimplencia'),
})
    .label('Dados da cobrança');
exports.schemaReturnGetChargeIdBBrasil = exports.yupReturnGetChargeIdBBrasil.shape({});
